import type { Nullable } from "@models";
import { createReducer, on } from "@ngrx/store";
import { IUpgradeChallengeOptionConfiguration } from "../../shared/model/newChallengeoptionConfiguration.model";
import { setUpgradeChallenge } from "./upgrade-challenge.actions";

export interface UpgradeChallengeState {
  upgradeChallenge: Nullable<IUpgradeChallengeOptionConfiguration>;
  error: Nullable<string>;
  isLoading: boolean;
}

const initialState: UpgradeChallengeState = {
  upgradeChallenge: null,
  isLoading: false,
  error: null,
};

export const upgradeChallengesReducer = createReducer(
  initialState,

  on(setUpgradeChallenge, (state, { selectedChallenge }) => ({
    ...state,
    isLoading: false,
    upgradeChallenge: selectedChallenge,
  })),
);
